<template>
  <b-modal
    ref="computedPropModal"
    hide-footer
    centered
    title="Create computed property"
    >
    <b-form @submit.prevent="create" novalidate>
      <b-form-group
        label="Property name:"
        >
        <b-form-input
          ref="propNameInput"
          type="text"
          autocomplete="off"
          v-model.trim="$v.propName.$model"
          :class="{ 'is-invalid': $v.propName.$error }"
          :disabled="inProgress"
          />
        <b-form-invalid-feedback v-if="!$v.propName.required">Property name is required</b-form-invalid-feedback>
        <b-form-invalid-feedback v-if="!$v.propName.isUnique">Property width the same name already exist</b-form-invalid-feedback>
      </b-form-group>
      <b-button
        type="submit"
        >
        Create
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'

export default {
  props: ['props', 'prop'],
  data () {
    return {
      inProgress: false,
      propName: ''
    }
  },
  methods: {
    create () {
      if (this.inProgress) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inProgress = true
      this.$v.$reset()

      this.$store.commit('addProcess', {
        process: 'createComputed',
        message: 'Creating'
      })

      db.computed.create(this.propName, () => {
        this.$store.commit('deleteProcess', 'createComputed')
        if (this.$refs.computedPropModal) this.$refs.computedPropModal.hide()
        let vm = this
        this.$store.commit('editComputed', {
          key: vm.propName,
          insert: true
        })
        this.inProgress = false
        this.propName = ''
        this.$nextTick(() => {
          this.$v.$reset()
        })
      })
    }
  },
  created () {
    eventBus.$on('showComputedPropModal', () => {
      if (this.$refs.computedPropModal) {
        this.$refs.computedPropModal.show()
        setTimeout(() => {
          this.$refs.propNameInput.focus()
        })
      }
    })
  },
  validations: {
    propName: {
      required,
      isUnique (val) {
        for (let prop in this.props) {
          if (prop === val) return false
        }
        return true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Modals/ComputedProp.vue